import { Schema } from './ProductAdditionalDetails.schema';

export function ProductAdditionalDetails() {
  // Return nothing, this component only used to store data
  return null;
}

ProductAdditionalDetails.displayName = 'ProductAdditionalDetails';
ProductAdditionalDetails.Schema = Schema;
